// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-5a96b612] .el-progress__text {\n  font-size: 20px !important;\n}", ""]);
// Exports
module.exports = exports;
